import { useCallback } from 'react';

import type { ActorCategoryId } from '@e-socna/data-layer';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

export const useActorCategoriesLabel = () => {
  const { actorCategoriesIdMap } = useReferencesContext();

  return useCallback(
    (categoryIds: readonly string[]) =>
      categoryIds
        .map(
          (categoryId) =>
            actorCategoriesIdMap[categoryId as ActorCategoryId]?.label ??
            'Inconnu',
        )
        .join(', '),
    [actorCategoriesIdMap],
  );
};
